import { Card } from '@/types/Board'
import { formatDate } from './formatDate'

function escapeCSVField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}

export function downloadCardsCSV(
  cards: Card[],
  filename: string = 'cards.csv',
  culture: string,
  treatment: string
) {
  if (cards.length === 0) {
    return
  }

  const headers = [
    'ID da demanda',
    'Nome da demanda',
    'area',
    'Data de cadastro',
    'Data de entrega',
    'Cliente',
    'Status',
    'Tags',
    'Cultura',
    'Tratamento',
    'Foi Reportada',
    'Tempo de reporte em aberto (horas)',
    'Mosaicamento'
  ]

  const cultures = {
    cane: 'Cana',
    soybean: 'Soja',
    cotton: 'Algodão'
  }

  const treatments = {
    weed: 'Daninhas',
    planting_failure: 'Growline',
    other: 'Outros'
  }

  const rows = cards.map((card) => {
    const tagsString = card.tags.map((tag) => tag.name).join(', ')
    const deliveryFormattedDate = formatDate(card.deliveryDate)
    const registrationDate = new Date(card.registrationDate)
    const registrationFormattedDate =
      registrationDate.toLocaleDateString('pt-BR')
    return [
      card.demandId,
      card.demandName,
      card.area,
      registrationFormattedDate,
      deliveryFormattedDate,
      card.companyName,
      card.status.label,
      tagsString,
      cultures[culture as keyof typeof cultures] ?? culture,
      treatments[treatment as keyof typeof treatments] ?? treatment,
      card.isReported ? 'Sim' : 'Não',
      card.reportWaitingTime,
      card.isMosaic ? 'Sim' : 'Não'
    ].map((field) => escapeCSVField(String(field ?? '')))
  })

  const csvContent = [
    headers.join(','),
    ...rows.map((row) => row.join(','))
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
